<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <list-component
      :service="service"
      :tableMetaData="tableMetaData"
    ></list-component>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import ListComponent from '../../../components/ListComponent.vue';
import services from '../../../services';

const { medicalRegistry } = services;
const { caseService, protocolNumberService } = medicalRegistry;

export default {
  name: 'case-list',
  components: {
    LandingCreate,
    ListComponent,
  },
  data() {
    const component = this;
    return {
      service: caseService,
      content: {
        pageTitle: 'Case',
        commands: [
          {
            link: 'case.create',
            icon: 'mdi-plus',
            buttonName: 'Create Case',
          },
        ],
        exportData: {
          active: true,
          isNavOpen: false,
          icon: 'mdi-file-export',
          buttonName: 'EXPORT DATA',
          title: 'Protocol Number - Specimens',
          headers: [
            { text: 'Protocol Number', value: 'protocolNumber' },
            { text: 'ID', value: '_id' },
          ],
          tableData: [],
          getListRemotely: async () => {
            const protocolNumbers = await protocolNumberService.getList();

            this.content.exportData.tableData = protocolNumbers;
          },
          onExportData: async ({ items }) => {
            const ids = items.map(({ _id }) => _id);
            const { data, filename } = await protocolNumberService
              .getFormResponsesAsXL({ items: ids });

            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            console.log(filename, 'lmaoooo');
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
          },
        },
      },
      tableMetaData: {
        tableFilters: {
          selections: [],
          dates: [
            {
              text: 'Date created',
              column: 'dateCreated',
            },
          ],
        },
        tableHeaders: [
          {
            text: 'Case Number',
            value: 'caseNumber',
          },
          {
            text: 'Created by',
            value: '_metadata.created.user.fullName',
          },
          {
            text: 'Date created',
            value: '_metadata.created.date',
          },
          {
            text: 'Actions',
            value: 'actions',
          },
        ],
        actions: {
          view: false,
        },
        URLName: 'case',
        actionDisplay: {
          delete: {
            visible: true,
            icon: () => 'mdi-delete-empty',
          },
        },
        onClickArchive(item) {
          component.onArchive(item);
        },
      },
    };
  }, // <-- end of return
  methods: {
    async onArchive(item) {
      console.log('test123');
      this.isLoading = true;
      try {
        await caseService.archive({ caseNumber: item });
        this.$snackbar.show({
          text: 'Successfully deleted Case!',
          closeColor: 'white',
          color: 'green',
        });
      } catch (e) {
        const { message } = e.response.data;
        this.$snackbar.show({ color: 'red', text: message, closeColor: 'white' });
      }
      this.isLoading = false;
    },
  },
};
</script>
